function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

class Popup extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.dialog = this.querySelector('dialog');
    this.closeButton = this.querySelector('.close-dialog-button');
    this.isThemeEditor = this.dataset.ThemeEditor;

    if (this.querySelector('[class*=form__message--success]')) {
      return;
    }

    this.closeButton.addEventListener('click', () => {
      this.dialog.close();
    });

    this.dialog.addEventListener('click', (event) => {
      if (event.target === this.dialog) {
        this.dialog.close();
      }
    });

    if (!Shopify.designMode && !this.hasAttribute('url-contain')) {
      setTimeout(() => {
        this.checkCookie();
      }, 5000);
    }
    if (this.hasAttribute('open')) {
      console.log('yoooooo');
      this.dialog.showModal();
    }
    if (this.hasAttribute('url-contain')) {
      this.checkUrl();
    }
  }

  checkUrl() {
    const url = window.location.href;
    const urlContain = this.getAttribute('url-contain');
    if (url.includes(urlContain)) {
      this.dialog.showModal();
    }
  }

  checkCookie() {
    const user = this.getCookie('popup');
    if (user != '') {
      this.dialog.close();
    } else {
      this.dialog.showModal();
      this.setCookie('popup', 'seen', this.dataset.cookieDuration);
    }
  }

  setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
  }

  getCookie(cname) {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return '';
  }
}

if (!customElements.get('mca-popup')) {
  customElements.define('mca-popup', Popup);
}
